<template>
  <Modal
    :isModalOpen="isModalOpen"
    :aboveAll="true"
    :darker="true"
    :hideButtonsContainer="true"
    :headerTitle="'Save your changes'"
    @closeModal="$emit('close')"
  >
    <template #content>
      <p class="text">Click on "Mark As Finished" to save your project</p>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Utils/Modal";
import { mapGetters, mapState } from "vuex";
export default {
  name: "PreventProjectDraftModal",
  components: { Modal },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showCopiedMessage: false,
    };
  },

  computed: {
    ...mapState("dealer", ["rhino_code"]),
    ...mapState("project", ["typeOfProject"]),
    ...mapGetters("project", ["projectId"]),
    ...mapState(["settings"]),

    title() {
      return ` Share your ${this.typeOfProject}`;
    },

    projectUrl() {
      return `${this.settings.gameplanUrl}${this.typeOfProject}s/${this.rhino_code}/${this.projectId}`;
    },

    shortProjectUrl() {
      return this.projectUrl.substring(0, 50) + "...";
    },
  },

  methods: {
    copyToClipboard() {
      // navigator clipboard api needs a secure context (https)
      const copy = () => {
        if (navigator.clipboard && window.isSecureContext) {
          // navigator clipboard api method'
          return navigator.clipboard.writeText(this.projectUrl);
        } else {
          // text area method
          let textArea = document.createElement("textarea");
          textArea.value = this.projectUrl;
          // make the textarea out of viewport
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          return new Promise((res, rej) => {
            document.execCommand("copy") ? res() : rej();
            textArea.remove();
          });
        }
      };
      copy().then(() => {
        this.showCopiedMessage = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  width: 25%;
  min-width: 400px;
  max-width: 600px;
  margin: auto;
  background: white;
  border-radius: 6px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    border-bottom: 1px solid $grey-light;
    p {
      text-transform: capitalize;
    }
  }

  .content {
    display: flex;
    flex-flow: column;
    padding: 1.3rem 1.5rem;
    p.text {
      color: $grey-dark;
      margin-bottom: 1rem;
    }

    .url-container {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eaeaea;
      border-radius: 6px;
      overflow: hidden;
      min-height: 3rem;
      .url {
        padding: 0.5rem;
        color: $dark;
        text-decoration: underline;
        min-width: 70%;
      }

      button {
        background-color: $dark;
        border-radius: 0 !important;
        color: white;
        padding: 0 0.5rem;
        flex: 1;
      }
    }

    p.msg {
      padding: 0.5rem 0;
      color: $green;
    }
  }

  @media screen and (max-width: 1024px) {
    width: 50%;
    min-width: initial;
  }
}
</style>
